import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="claim-reexports"
export default class extends Controller {
  static targets = ["button", "checkbox", "selectAll"]
  static values = { newUrl: String }

  connect() {
    this.refresh()
  }

  checkboxTargetConnected() {
    this.refresh()
  }

  checkboxTargetDisconnected() {
    this.refresh()
  }

  selectAllTargetConnected() {
    this.refresh()
  }

  toggleAll(event) {
    this.checkboxes().forEach((checkbox) => {
      checkbox.checked = event.target.checked
    })
    this.refresh()
  }

  refresh() {
    const selectedCount = this.selectedIds().length

    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = selectedCount === 0
      this.buttonTarget.textContent = selectedCount > 0 ? `Re-export selected (${selectedCount})` : "Re-export selected"
    }

    if (this.hasSelectAllTarget) {
      const boxes = this.checkboxes()
      const checkedCount = boxes.filter((checkbox) => checkbox.checked).length
      this.selectAllTarget.checked = boxes.length > 0 && checkedCount === boxes.length
      this.selectAllTarget.indeterminate = checkedCount > 0 && checkedCount < boxes.length
    }
  }

  open(event) {
    event.preventDefault()
    const ids = this.selectedIds()
    if (ids.length === 0 || !this.hasNewUrlValue) return

    const url = new URL(this.newUrlValue, window.location.origin)
    ids.forEach((id) => url.searchParams.append("claim_ids[]", id))

    const drawerEvent = new Event("drawer.open")
    drawerEvent.url = url.toString()
    document.dispatchEvent(drawerEvent)
  }

  selectedIds() {
    return this.checkboxes()
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.dataset.claimId)
      .filter(Boolean)
  }

  checkboxes() {
    return Array.from(this.element.querySelectorAll("input[data-claim-id]"))
  }
}
